import { useAppSelector } from '@/store';
import { ROUTES } from '@/utils/constants';

export interface PrereqItem {
  label: string;
  message: string;
  to: string;
}

// Preflight checks the RM must satisfy before they can send emails. Right now
// the only employee-owned prerequisite is the Employee Code (required to mint
// the reference number); add new dependencies here as they appear.
export const useEmailSendPrereqs = (): { ready: boolean; items: PrereqItem[] } => {
  const employeeCode = useAppSelector((state) => state.auth.user?.employeeCode);

  const items: PrereqItem[] = [];
  if (!employeeCode) {
    items.push({
      label: 'Employee Code',
      message:
        'Set your Employee Code in your Profile - it is required to generate the email reference number.',
      to: ROUTES.SALES_RM_PROFILE,
    });
  }

  return { ready: items.length === 0, items };
};
